export default "__VITE_ASSET__CrQS8QoA__"